export default __webpack_public_path__ + "static/media/koia-masterImage.5c8846d8.png";